import { render, staticRenderFns } from "./EditClaim.vue?vue&type=template&id=53437dca&"
import script from "./EditClaim.vue?vue&type=script&lang=js&"
export * from "./EditClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports